import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { object } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { FluxosPagamentoProvider } from '../../../../contexts/FluxosPagamentoContext'
import { useGlobal } from '../../../../contexts/GlobalContext'
import { useReativacaoAssinatura } from '../../../../contexts/ReativacaoAssinaturaContext'
import FluxosPagamento from '../../../../components/FluxosPagamento/FluxosPagamento'
import BreadcrumbGlobal from '../../../../components/BreadcrumbGlobal/BreadcrumbGlobal'
import { TIPO_PROMOCAO_REATIVACAO_ASSINATURA } from '../../../../components/CupomPromocao/constantsPromocao'
import { EVENTOS_GA, FLUXOS_PAGAMENTO, STATUS_CANCELADO, ROUTE_BASEPATH, INFORMACAO_MODALIDADES } from '../../../../constants'
import { isEmptyObject } from '../../../../utils/helpers/helpers'
import { DESCRICAO_PAGINA_REATIVACAO, LABEL_BOTAO_REATIVACAO, TITULO_PAGINA_REATIVACAO } from './constantsReativacaoAssinatura'
import { navigate } from '@reach/router'
import { TIPOS_FLUXO_BRINDES } from '../../../../components/FluxosPagamento/constantsFluxosPagamento'
import { getAssinaturaDoAssociadoPorModalidade, getInformacoesModalidadePorAssinatura } from '../../../../utils/helpers/helpersAssinatura'
import { URLS_APP } from '../../../../config'
import { criarUsuarioLog, TIPOS_LOG_USUARIO } from '../../../../api/usuarioLog.servico'

const Titulo = styled.h1`
  margin: 25px 0 10px 0;
`

const SubTitulo = styled.h3`
  ${StyleGuide.tipografia.textoDefault};
  margin: 0;

  span {
    ${StyleGuide.boldFonte};
  }
`

const ReativacaoAssinatura = ( { location } ) => {
  const visualizacaoInicialBreadcrumb = [ 'Plano', 'Entrega', 'Pagamento', 'Conclusão' ]
  const { dadosGlobaisAssociado, modalidadeURL, setFluxoGA, verifyAtMaintenance } = useGlobal()
  const {
    dadosRetornoRequisicao,
    loadingReativacaoAssinatura,
    postReativarAssinatura,
    sucessoReativacao,
    setLoadingReativacaoAssinatura
  } = useReativacaoAssinatura()
  const [ assinaturaModalidadeCancelada, setAssinaturaModalidadeCancelada ] = useState()
  const [ brindesFluxo, setBrindesFluxo ] = useState( [] )
  const [ dadosDescontoCombo, setDadosDescontoCombo ] = useState( {} )
  const [ visualizacaoBreadcrumb, setVisualizacaoBreadcrumb ] = useState( visualizacaoInicialBreadcrumb )

  useEffect( () => {
    if ( dadosGlobaisAssociado && dadosGlobaisAssociado.assinaturas.length ) {
      const modalidadeIncluidaPathname = location.pathname.split( '/' ).find( path => {
        const infoModalidadeIncluidaNoPathname = INFORMACAO_MODALIDADES.find( modalidade => modalidade.slug === path )
        return !isEmptyObject( infoModalidadeIncluidaNoPathname )
      } )
      let assinaturaPorModalidade
      if ( modalidadeIncluidaPathname ) {
        assinaturaPorModalidade = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeIncluidaPathname )
      }
      let assinaturaCanceladaPorModalidade = {}
      if ( assinaturaPorModalidade && assinaturaPorModalidade.status === STATUS_CANCELADO ) {
        assinaturaCanceladaPorModalidade = assinaturaPorModalidade
      }
      setAssinaturaModalidadeCancelada( assinaturaCanceladaPorModalidade )
    }

    setFluxoGA( EVENTOS_GA.REATIVACAO.FLUXO )
  }, [ location ] )

  useEffect( () => {
    criarUsuarioLog( TIPOS_LOG_USUARIO.INICIOU_CHECKOUT_ADA_REATIVAR )
  }, [] )

  const fazerReativacaoAssinatura = async( dadosFluxo, setEtapaAtiva ) => {
    setLoadingReativacaoAssinatura( true )
    const atMaintenance = await verifyAtMaintenance()
    if ( !isEmptyObject( dadosFluxo ) && !isEmptyObject( assinaturaModalidadeCancelada ) && !atMaintenance ) {
      await postReativarAssinatura( assinaturaModalidadeCancelada, dadosFluxo, setEtapaAtiva )
    } else {
      setLoadingReativacaoAssinatura( false )
    }
  }

  const montarFluxoComBrindes = brindes => {
    if ( brindes.length > 1 ) {
      setBrindesFluxo( brindes )
      setVisualizacaoBreadcrumb( [ 'Plano', 'Entrega', 'Pagamento', 'Brinde', 'Conclusão' ] )
    } else {
      setBrindesFluxo( [] )
      setVisualizacaoBreadcrumb( visualizacaoInicialBreadcrumb )
    }
  }

  if ( assinaturaModalidadeCancelada ) {
    if ( isEmptyObject( assinaturaModalidadeCancelada ) ) {
      navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${modalidadeURL}` )
      return null
    } else {
      return (
        <Fragment>
          <BreadcrumbGlobal
            exactPath="reativar-assinatura"
            nomeAlternativo="Reativar Assinatura"
            palavrasExcluidas={ /entrega|pagamento|brindes|conclusao/u }
          />

          <Titulo>
            { TITULO_PAGINA_REATIVACAO }
          </Titulo>

          <SubTitulo>
            { DESCRICAO_PAGINA_REATIVACAO }
          </SubTitulo>

          <FluxosPagamentoProvider
            descontoCombo={ setDadosDescontoCombo }
            fluxoPagamentoAtual={ TIPOS_FLUXO_BRINDES[ FLUXOS_PAGAMENTO.REATIVACAO ] }
            idAssinaturaAtual={ assinaturaModalidadeCancelada.id }
            modalidadeParaBrinde={ getInformacoesModalidadePorAssinatura( modalidadeURL ).id }
            montarFluxoComBrindes={ montarFluxoComBrindes }
          >
            <FluxosPagamento
              visualizacaoEtapas={ visualizacaoBreadcrumb }
            >
              <FluxosPagamento.Plano />

              <FluxosPagamento.Entrega />

              <FluxosPagamento.Pagamento />

              {
                brindesFluxo.length ?
                  <FluxosPagamento.Brindes
                    brindesFluxo={ brindesFluxo }
                  /> : []
              }

              <FluxosPagamento.Conclusao
                concluirFluxo={ dados => fazerReativacaoAssinatura( dados ) }
                dadosDescontoCombo={ dadosDescontoCombo }
                dadosRetornoRequisicao={ dadosRetornoRequisicao }
                fluxo={ FLUXOS_PAGAMENTO.REATIVACAO }
                fluxoTemPromocao
                idAssinatura={ assinaturaModalidadeCancelada.id }
                labelBotaoUltimaEtapa={ LABEL_BOTAO_REATIVACAO }
                loadingRequisicao={ loadingReativacaoAssinatura }
                respostaRequisicao={ sucessoReativacao }
                tipoAssinaturaPromocao={ TIPO_PROMOCAO_REATIVACAO_ASSINATURA }
              />
            </FluxosPagamento>
          </FluxosPagamentoProvider>
        </Fragment>
      )
    }
  }
  return null
}

ReativacaoAssinatura.propTypes = {
  'location': object.isRequired
}

export default ReativacaoAssinatura
